export enum LanguageType {
  DK = 'da-DK',
  EN = 'en-US',
  DE = 'de-DE',
}